import { createAction } from 'redux-actions';

export const VERIFY_VOUCHER_CODE_REQUEST = createAction('VERIFY_VOUCHER_CODE_REQUEST');
export const VERIFY_VOUCHER_CODE_FAILURE = createAction('VERIFY_VOUCHER_CODE_FAILURE');
export const VERIFY_VOUCHER_CODE_SUCCESS = createAction('VERIFY_VOUCHER_CODE_SUCCESS');
